/* eslint-disable import/no-anonymous-default-export */
export default {
  styleOverrides: {
    root: {
      padding: "24px 0px 24px 0px",
    },
  },
}
